import { createFileRoute } from '@tanstack/react-router'
import { Cards } from '@/components/cards/Cards'

export const Route = createFileRoute('/_mainLayout/cards/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Cards />
}
